import { isUndefined } from 'lodash';

export const numberFieldHasValue = (value: number | undefined): boolean => {
	return !isUndefined(value) && value !== null && value !== 0;
};

export const stringFieldHasValue = (value: string | undefined): boolean => {
	return !isUndefined(value) && value !== null && value !== '';
};
